import genBlogIcon from '../../../assets/gen_blog.svg';
import genEmailIcon from '../../../assets/gen_email.svg';
import genSocialIcon from '../../../assets/gen_social.svg';
import { ResourceType } from './types';
export interface ResourceConfig {
	iconPath: string;
	backgroundColor: string;
	title: string;
	description: string;
	buttonText: string;
	reportPath: string;
	reportLabel: string;
	completedStatusLabel: string;
	createDescription: (sourceType: ResourceType) => string;
}

export const RESOURCE_ROUTES: Record<ResourceType, string> = {
	email: '/email/campaigns/create/from-scratch',
	social: '/social-media/post/create',
	blog: '/blog/post/create',
};

export const CONTENT_TYPE_MAP: Record<ResourceType, string> = {
	email: 'Email',
	social: 'Social',
	blog: 'Blog',
};

export const RESOURCE_CONFIG: Record<ResourceType, ResourceConfig> = {
	email: {
		iconPath: genEmailIcon,
		backgroundColor: '#DBF2C3',
		title: 'Create Email Campaign',
		description: 'Create a unique email campaign based on your primary campaign',
		buttonText: 'Create Emails with AI',
		reportPath: '/reporting/group-email',
		reportLabel: 'Group Email Reports',
		completedStatusLabel: 'Email Campaign Created',
		createDescription: (sourceType: ResourceType) => {
			const sourceMap = {
				email: 'email content',
				social: 'social media post',
				blog: 'blog article',
			};
			return `Create a unique email campaign based on this ${sourceMap[sourceType]}`;
		},
	},
	social: {
		iconPath: genSocialIcon,
		backgroundColor: 'rgba(0, 204, 255, 0.1)',
		title: 'Create Social Media Post',
		description: 'Create a unique social media post based on your primary campaign',
		buttonText: 'Create Posts with AI',
		reportPath: '/reporting/social-media-posts',
		reportLabel: 'Social Media Reports',
		completedStatusLabel: 'Social Post Created',
		createDescription: (sourceType: ResourceType) => {
			const sourceMap = {
				email: 'email content',
				social: 'social media post',
				blog: 'blog article',
			};
			return `Create a unique social media post based on this ${sourceMap[sourceType]}`;
		},
	},
	blog: {
		iconPath: genBlogIcon,
		backgroundColor: 'rgba(139, 61, 198, 0.16)',
		title: 'Create Blog Article',
		description: 'Create a unique blog article based on your primary campaign',
		buttonText: 'Create Blogs with AI',
		reportPath: '/reporting/blogs',
		reportLabel: 'Blog Reports',
		completedStatusLabel: 'Blog Article Created',
		createDescription: (sourceType: ResourceType) => {
			const sourceMap = {
				email: 'email content',
				social: 'social media post',
				blog: 'blog article',
			};
			return `Create a unique blog article based on this ${sourceMap[sourceType]}`;
		},
	},
};

export const getResourceConfig = (type: ResourceType): ResourceConfig => {
	return RESOURCE_CONFIG[type];
};

export const getAllResourceTypes = (): ResourceType[] => {
	return Object.keys(RESOURCE_CONFIG) as ResourceType[];
};

export const getOtherResourceTypes = (excludeType: ResourceType): ResourceType[] => {
	return getAllResourceTypes().filter(type => type !== excludeType);
};
